import { VueConstructor } from 'vue';

declare global {
  interface JSON {
    stringifyToHTML: (value: any, replacer?: ((this: any, key: string, value: any) => any) | undefined, space?: string | number | undefined) => string;
  }
}

export default {
  stringifyToHTML(value: any, replacer?: ((this: any, key: string, value: any) => any) | undefined, space?: string | number | undefined): string {
    if (value === undefined) {
      return '<span style="color:#569cd6">undefined</span>';
    }
    if (value === null) {
      return '<span style="color:#569cd6">null</span>';
    }
    let obj = value;
    if (typeof value === 'string' && value.trim().startsWith('{')) {
      try {
        // simply convenience for parsing objects that come as strings
        obj = JSON.parse(value);
      } catch (error: any) {
        return `<span style="color:#ce9178">"${value}"</span>`;
      }
    } else if (typeof value === 'string') {
      return `<span style="color:#ce9178">"${value}"</span>`;
    }
    return JSON.stringify(obj, replacer, space ?? 2)
      // breaks
      .replace(/(\n)/g, '<br>')
      // spaces
      .replace(/\s/g, '&nbsp;')
      // strings
      .replace(/:(\s|&nbsp;)+?["'](.*?)["']/g, ': <span style="color:#ce9178">"$2"</span>')
      // numbers
      .replace(/:(\s|&nbsp;)+?([+-]?([0-9]*[.])?[0-9]+)/g, ': <span style="color:#b0cea8">$2</span>')
      // booleans
      .replace(/false/g, '<span style="color:#569cd6">false</span>')
      .replace(/true/g, '<span style="color:#569cd6">true</span>');
  },
};
